(() => {
  if (customElements.get('gvs-before-after')) return;

  class GVSBeforeAfter extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('[data-gvs-before-after-range]');
      if (!this.range) return;

      this.update = this.update.bind(this);
      this.range.addEventListener('input', this.update, { passive: true });
      this.range.addEventListener('change', this.update, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      if (!this.range) return;
      this.range.removeEventListener('input', this.update);
      this.range.removeEventListener('change', this.update);
    }

    update() {
      const rawValue = Number(this.range.value);
      const value = Math.min(100, Math.max(0, Number.isFinite(rawValue) ? rawValue : 50));
      this.style.setProperty('--gvs-ba-position', `${value}%`);
    }
  }

  customElements.define('gvs-before-after', GVSBeforeAfter);
})();